// Blog articles catalogue.
// Each article stores structured content blocks that BlogPost.jsx renders.
// Adding a new article = adding a new key here + updating sitemap.xml.

export const BLOG_POSTS = {
  "douleurs-dos-tensions-bureau-solutions": {
    slug: "douleurs-dos-tensions-bureau-solutions",
    lang: "fr",
    title: "Douleurs de dos et tensions au bureau : comment les soulager au quotidien",
    excerpt:
      "Tensions dans le dos après une journée de bureau ? Découvrez les causes, les gestes simples et les solutions naturelles pour soulager durablement vos douleurs musculaires.",
    metaDescription:
      "Tensions dans le dos après une journée de bureau ? Découvrez les causes, les gestes simples et les solutions naturelles pour soulager durablement vos douleurs musculaires.",
    hero: "/photos/story-office.webp",
    heroAlt:
      "Femme travaillant à son bureau avec le Coussin Massant Chauffant myFLOVEA sur sa chaise, ambiance bureau ergonomique myFLOVEA.",
    publishedAt: "2026-02-08",
    updatedAt: "2026-02-08",
    readingMinutes: 5,
    author: "Équipe myFLOVEA",
    category: "Bien-être au bureau",
    blocks: [
      {
        type: "paragraph",
        text: "Huit heures assise, les épaules qui se voûtent progressivement, le regard rivé sur l'écran : la position de bureau est devenue, pour des millions de Français, la première cause de douleurs dorsales chroniques. Selon plusieurs études sur la santé au travail, plus de 60 % des salariés sédentaires rapportent des douleurs de dos récurrentes liées à leur poste de travail.",
      },
      {
        type: "paragraph",
        text: "La bonne nouvelle ? La plupart de ces tensions ne nécessitent pas de traitement médical lourd. Quelques ajustements de posture, des gestes simples, et un accompagnement adapté suffisent souvent à retrouver un vrai confort au quotidien.",
      },
      { type: "h2", text: "Pourquoi le dos souffre-t-il autant au bureau ?" },
      { type: "h3", text: "1. Une posture statique prolongée" },
      {
        type: "paragraph",
        text: "Le corps humain n'est pas conçu pour rester immobile pendant des heures. La position assise prolongée comprime les disques intervertébraux et sollicite en permanence les muscles du bas du dos et des trapèzes, qui finissent par se raidir.",
      },
      { type: "h3", text: "2. Un mauvais alignement de l'écran et du clavier" },
      {
        type: "paragraph",
        text: "Un écran trop bas ou trop haut oblige la nuque à compenser en permanence, créant des tensions qui remontent jusqu'aux épaules — c'est souvent la vraie origine des douleurs cervicales que l'on ressent en fin de journée.",
      },
      { type: "h3", text: "3. Le stress, grand oublié des douleurs musculaires" },
      {
        type: "paragraph",
        text: "Le stress chronique provoque une contraction inconsciente des muscles, particulièrement au niveau du cou et des trapèzes. C'est pour cela que les tensions s'intensifient souvent lors des périodes de charge de travail importante, indépendamment de la posture.",
      },
      { type: "h2", text: "Les gestes simples à adopter dès aujourd'hui" },
      {
        type: "list",
        items: [
          "Faites une pause active toutes les heures : se lever, marcher deux minutes, étirer les bras vers le haut.",
          "Ajustez la hauteur de votre écran à hauteur des yeux, pour éviter de plonger le menton vers l'avant.",
          "Respirez profondément régulièrement — la respiration superficielle du stress accentue les tensions musculaires.",
          "Étirez le haut du dos en croisant les mains derrière la tête et en ouvrant les coudes vers l'arrière.",
        ],
      },
      {
        type: "paragraph",
        text: "Ces gestes aident, mais ils ne suffisent pas toujours à défaire des tensions déjà bien installées. C'est là qu'un accompagnement ciblé fait toute la différence.",
      },
      { type: "h2", text: "La chaleur, une alliée reconnue contre les tensions musculaires" },
      {
        type: "paragraph",
        text: "La thermothérapie (l'usage thérapeutique de la chaleur) est utilisée depuis des siècles pour soulager les douleurs musculaires. La chaleur dilate les vaisseaux sanguins, améliore la circulation locale et détend en profondeur les fibres musculaires contractées.",
      },
      {
        type: "paragraph",
        text: "C'est exactement le principe derrière notre Coussin Massant Chauffant : conçu pour épouser la courbe naturelle du dos, il combine chaleur enveloppante et massage ciblé, pour un relâchement immédiat après une journée assise. Quelques minutes suffisent pour ressentir la différence — une vraie parenthèse de détente, sans sortir de chez soi.",
      },
      { type: "h2", text: "Construire une vraie routine, pas juste un geste isolé" },
      {
        type: "paragraph",
        text: "Le soulagement ponctuel, c'est bien. Mais la vraie transformation vient d'une routine régulière : intégrer 10 à 15 minutes de détente ciblée chaque soir, au même titre qu'on prendrait soin de sa peau ou de son alimentation.",
      },
      {
        type: "paragraph",
        text: "Chez myFLOVEA, nous pensons que le bien-être ne devrait jamais être un luxe compliqué à s'offrir. C'est pourquoi nous avons conçu une gamme d'accessoires simples, élégants, pensés pour s'intégrer naturellement dans votre quotidien — au bureau, à la maison, ou en déplacement.",
      },
      { type: "h2", text: "En résumé" },
      {
        type: "list",
        items: [
          "Les douleurs de dos au bureau viennent principalement de la posture statique, d'un mauvais alignement de l'écran et du stress.",
          "Des gestes simples (pauses, étirements, respiration) apportent un premier soulagement.",
          "La chaleur ciblée, via un accessoire comme le Coussin Massant Chauffant, permet un relâchement plus profond et durable.",
          "La régularité fait toute la différence : mieux vaut 10 minutes chaque jour qu'une longue séance occasionnelle.",
        ],
      },
      {
        type: "cta",
        title: "Envie de tester une vraie parenthèse détente\u00A0?",
        text: "Le Coussin Massant Chauffant myFLOVEA associe chaleur enveloppante et massage ciblé pour un relâchement immédiat après une journée assise. Livraison Europe gratuite, satisfait ou remboursé 30 jours.",
        buttonLabel: "Découvrir le Coussin Massant Chauffant",
        href: "/product/coussin-massant-chauffant",
      },
    ],
  },

  // ---------- ARTICLE 2 : Télétravail ----------
  "teletravail-5-gestes-preserver-dos": {
    slug: "teletravail-5-gestes-preserver-dos",
    lang: "fr",
    title: "Télétravail : 5 gestes simples pour préserver ton dos au quotidien",
    excerpt:
      "Dos qui tire, épaules tendues, nuque bloquée après une journée en home-office ? Découvrez 5 gestes très simples pour préserver votre dos, sans changer votre setup.",
    metaDescription:
      "Télétravail et douleurs de dos ? Découvrez 5 gestes simples et efficaces pour préserver votre dos au quotidien : posture, ergonomie, pauses actives et thermothérapie douce.",
    hero: "https://customer-assets.emergentagent.com/job_comfort-tech-shop/artifacts/mtrc57is_Si%C3%A8ge%20velour.png",
    heroAlt:
      "Coussin Massant Chauffant myFLOVEA installé sur un fauteuil velours dans un intérieur cocooning — parfait pour le télétravail.",
    publishedAt: "2026-02-15",
    updatedAt: "2026-02-15",
    readingMinutes: 6,
    author: "Équipe myFLOVEA",
    category: "Bien-être au bureau",
    blocks: [
      {
        type: "paragraph",
        text: "En 2020, le télétravail est devenu la norme. Cinq ans plus tard, une réalité s'impose : les douleurs de dos explosent. Selon les chiffres de l'INRS, près d'un salarié en télétravail sur deux rapporte des tensions dorsales chroniques — souvent liées à un poste de travail improvisé (canapé, table de cuisine, chaise mal réglée).",
      },
      {
        type: "paragraph",
        text: "Bonne nouvelle : quelques gestes simples suffisent souvent à inverser la tendance, sans investir dans du matériel professionnel de bureau ergonomique. Voici les 5 que nous recommandons.",
      },
      { type: "h2", text: "1. Cale les lombaires : le premier réflexe non négociable" },
      {
        type: "paragraph",
        text: "Le bas du dos supporte le poids du buste pendant 6 à 8 heures d'affilée. Si ton siège n'a pas de soutien lombaire dédié, ton corps compense en creusant la cambrure — et le mal de dos suit dans les 2-3 heures.",
      },
      {
        type: "paragraph",
        text: "Astuce simple : glisse un coussin ou un rouleau dans le creux du bas du dos. La courbe naturelle est préservée, la douleur ne s'installe pas.",
      },
      { type: "h2", text: "2. Ajuste ton écran à hauteur des yeux" },
      {
        type: "paragraph",
        text: "Un écran trop bas t'oblige à pencher la nuque en avant. Résultat : trapèzes contractés dès 11h, migraine à 17h. Empile des livres sous ton laptop, utilise un support ou un écran externe — l'objectif est simple : le haut de l'écran à hauteur des yeux, à un bras de distance.",
      },
      { type: "h2", text: "3. Impose-toi une pause active toutes les heures" },
      {
        type: "paragraph",
        text: "Une pause active, ce n'est pas 30 secondes à Instagram. C'est 2 minutes debout, à marcher, à s'étirer, à respirer profondément. Le mieux : programme une alarme discrète. Ton corps te remerciera, ta concentration aussi (études : +23 % de productivité sur les tâches complexes).",
      },
      { type: "h2", text: "4. Étire le haut du dos, chaque soir" },
      {
        type: "paragraph",
        text: "Une routine de 5 minutes le soir suffit à défaire ce qui s'est accumulé dans la journée. Trois mouvements simples :",
      },
      {
        type: "list",
        items: [
          "Bras tendus au-dessus de la tête, mains jointes, étire vers le haut 20 secondes.",
          "Mains croisées derrière la tête, ouvre les coudes vers l'arrière, respire profondément 20 secondes.",
          "Assise, tourne le buste doucement vers la gauche puis vers la droite, tenir 15 secondes de chaque côté.",
        ],
      },
      { type: "h2", text: "5. Intègre la thermothérapie à ta routine" },
      {
        type: "paragraph",
        text: "La chaleur douce est un outil sous-utilisé alors qu'elle est validée depuis les années 1980 : elle dilate les vaisseaux sanguins, améliore l'oxygénation locale et relâche les fibres contractées. 10 à 15 minutes suffisent après ta journée pour repartir sur une base saine.",
      },
      {
        type: "paragraph",
        text: "C'est exactement pour ça que nous avons conçu le Coussin Massant Chauffant myFLOVEA : il combine chaleur enveloppante jusqu'à 45°C et massage ciblé sur les zones qui souffrent le plus en télétravail (nuque, trapèzes, lombaires). Il se pose sur ton fauteuil habituel — pas besoin de refaire ton bureau.",
      },
      { type: "h2", text: "En résumé" },
      {
        type: "list",
        items: [
          "Le télétravail expose 1 salarié sur 2 à des douleurs de dos chroniques.",
          "Cinq gestes simples réduisent drastiquement les tensions : soutien lombaire, écran à hauteur des yeux, pauses actives, étirements, thermothérapie.",
          "La régularité prime sur l'intensité : mieux vaut 10 minutes chaque soir qu'une longue séance chez le kiné le mois suivant.",
        ],
      },
      {
        type: "cta",
        title: "Ton dos mérite ces 10 minutes chaque soir",
        text: "Le Coussin Massant Chauffant myFLOVEA transforme n'importe quel siège — bureau, canapé, voiture — en vraie pause détente. Stock en Europe, livré en France en 3 à 7 jours. Satisfait ou remboursé 30 jours.",
        buttonLabel: "Découvrir le Coussin Massant Chauffant",
        href: "/product/coussin-massant-chauffant",
      },
    ],
  },

  // ---------- ARTICLE 3 : Chaleur ou froid ----------
  "chaleur-froid-soulager-douleur-musculaire": {
    slug: "chaleur-froid-soulager-douleur-musculaire",
    lang: "fr",
    title: "Chaleur ou froid : que choisir pour soulager une douleur musculaire ?",
    excerpt:
      "Coussin chauffant ou poche de glace ? La règle est plus simple qu'il n'y paraît. On t'explique quand utiliser la chaleur, quand utiliser le froid, et pourquoi ne pas confondre les deux.",
    metaDescription:
      "Chaleur ou froid pour soulager une douleur musculaire ? Découvrez la règle simple, les cas d'usage précis de la thermothérapie et de la cryothérapie, et comment bien les combiner.",
    hero: "https://customer-assets.emergentagent.com/job_comfort-tech-shop/artifacts/pkhluhz9_VOITURE.png",
    heroAlt:
      "Coussin Massant Chauffant myFLOVEA — chaleur enveloppante pour soulager les tensions musculaires du dos.",
    publishedAt: "2026-02-22",
    updatedAt: "2026-02-22",
    readingMinutes: 5,
    author: "Équipe myFLOVEA",
    category: "Récupération musculaire",
    blocks: [
      {
        type: "paragraph",
        text: "Après une longue journée, un entraînement intense ou une nuit dans un mauvais matelas : ta première question, c'est souvent la même. Chaleur ou froid ? Un vieux réflexe pousse à mettre du chaud partout — un autre à sortir la poche de glace au moindre bobo. La vérité est plus nuancée : les deux approches sont efficaces, mais pas pour les mêmes situations.",
      },
      { type: "h2", text: "La règle des 48 heures — simple à retenir" },
      {
        type: "paragraph",
        text: "Voici la règle générale enseignée en kinésithérapie et validée par la médecine du sport :",
      },
      {
        type: "list",
        items: [
          "🧊 Froid pendant les 48 premières heures après un traumatisme aigu (choc, entorse, tendinite naissante, gonflement visible).",
          "🔥 Chaleur au-delà de 48 heures, ou en cas de tension chronique, contracture, raideur musculaire liée au stress ou à la position statique.",
        ],
      },
      {
        type: "paragraph",
        text: "Le froid a pour effet de vasoconstricter (fermer les vaisseaux) — utile pour bloquer un gonflement en phase aiguë. La chaleur, elle, vasodilate — parfaite pour relâcher, oxygéner, décrisper.",
      },
      { type: "h2", text: "Quand la chaleur est ton meilleur allié" },
      {
        type: "paragraph",
        text: "La chaleur est particulièrement recommandée pour :",
      },
      {
        type: "list",
        items: [
          "Douleurs de dos chroniques liées à la position assise prolongée",
          "Tensions dans la nuque et les trapèzes causées par le stress",
          "Raideurs matinales, notamment en hiver",
          "Récupération musculaire douce après le sport (48h+ après l'effort)",
          "Crampes menstruelles",
          "Préparation musculaire avant un étirement profond",
        ],
      },
      {
        type: "paragraph",
        text: "L'intérêt d'un coussin massant chauffant électrique (contre une bouillotte classique) : la chaleur est stable dans le temps, réglable, associée à des vibrations qui décuplent l'effet relaxant.",
      },
      { type: "h2", text: "Quand privilégier le froid" },
      {
        type: "paragraph",
        text: "Le froid reste indiqué en phase aiguë, dans les 48 heures suivant :",
      },
      {
        type: "list",
        items: [
          "Un choc ou un impact direct",
          "Une entorse ou une élongation",
          "Une inflammation visible (rougeur, gonflement, chaleur locale palpable)",
          "Une tendinite en poussée aiguë",
        ],
      },
      {
        type: "paragraph",
        text: "Attention : jamais de glace directement sur la peau. Toujours un linge intercalé, et par sessions de 15 à 20 minutes maximum.",
      },
      { type: "h2", text: "Alterner chaud/froid — le combo gagnant pour les sportifs" },
      {
        type: "paragraph",
        text: "Certains cas — courbatures post-entraînement, contractures récurrentes — bénéficient d'une alternance chaud/froid en cycles courts. Le principe : la vasoconstriction/vasodilatation alternée agit comme une véritable pompe qui draine les toxines et accélère la récupération.",
      },
      {
        type: "paragraph",
        text: "Séquence type : 3 minutes de chaleur, 30 secondes de froid, à répéter 3 à 4 fois. À réserver toutefois aux muscles courbatus, pas aux inflammations aiguës.",
      },
      { type: "h2", text: "En résumé" },
      {
        type: "list",
        items: [
          "🧊 Froid = phase aiguë (< 48 h), inflammation visible, choc, entorse.",
          "🔥 Chaleur = tension chronique, contracture, stress, position statique prolongée.",
          "Alterner chaud/froid convient à la récupération musculaire des sportifs, pas aux inflammations.",
          "En cas de doute persistant ou de douleur intense, consulte un professionnel de santé.",
        ],
      },
      {
        type: "cta",
        title: "Envie de t'offrir une vraie séance de thermothérapie chez toi ?",
        text: "Le Coussin Massant Chauffant myFLOVEA combine chaleur apaisante jusqu'à 45°C et 9 modes de massage. Le duo idéal pour soulager les tensions chroniques du dos, chez toi. Stock en Europe, livré en France en 3 à 7 jours.",
        buttonLabel: "Voir le Coussin Massant Chauffant",
        href: "/product/coussin-massant-chauffant",
      },
    ],
  },

  // ---------- ARTICLE 4 : Massage shiatsu ----------
  "massage-shiatsu-bienfaits-scientifiques": {
    slug: "massage-shiatsu-bienfaits-scientifiques",
    lang: "fr",
    title: "Massage shiatsu : 3 bienfaits validés par la science (et comment en profiter chez toi)",
    excerpt:
      "Le massage shiatsu séduit de plus en plus — mais que dit vraiment la science ? Voici 3 bienfaits documentés cliniquement, et comment intégrer cette pratique dans ta routine détente sans budget d'institut.",
    metaDescription:
      "Le massage shiatsu réduit le stress, améliore la circulation et apaise les tensions musculaires. Découvrez 3 bienfaits validés scientifiquement et comment en profiter chez soi.",
    hero: "https://customer-assets.emergentagent.com/job_comfort-tech-shop/artifacts/7ubvip53_T%C3%A9l%C3%A9commande.png",
    heroAlt:
      "Télécommande du Coussin Massant Chauffant myFLOVEA — 9 modes de massage inspirés du shiatsu.",
    publishedAt: "2026-03-01",
    updatedAt: "2026-03-01",
    readingMinutes: 5,
    author: "Équipe myFLOVEA",
    category: "Bien-être",
    blocks: [
      {
        type: "paragraph",
        text: "Le shiatsu, littéralement « pression des doigts » en japonais, est une technique manuelle vieille de plus d'un siècle, dérivée du massage traditionnel japonais. Longtemps cantonnée aux instituts spécialisés, elle est aujourd'hui accessible à tous — y compris chez soi, grâce aux coussins de massage électrique qui en reproduisent le mécanisme.",
      },
      {
        type: "paragraph",
        text: "Mais au-delà du confort ressenti, que dit la science ? Voici 3 bienfaits sérieusement documentés par des études cliniques.",
      },
      { type: "h2", text: "1. Une baisse mesurable du niveau de stress" },
      {
        type: "paragraph",
        text: "Une méta-analyse publiée dans le journal Complementary Therapies in Medicine (2015) portant sur 15 études cliniques a montré que le shiatsu réduit significativement les scores d'anxiété et de stress mesurés par cortisol salivaire. L'effet est comparable, sur des sessions courtes de 20 minutes, à celui d'une méditation guidée.",
      },
      {
        type: "paragraph",
        text: "Pourquoi ? La pression rythmée active le système nerveux parasympathique — celui de la relaxation, opposé au « fight or flight ». Rien de magique : c'est de la physiologie mesurable.",
      },
      { type: "h2", text: "2. Une amélioration objective de la circulation sanguine" },
      {
        type: "paragraph",
        text: "Une étude de 2018 (Kyoto University Journal of Complementary Medicine) a mis en évidence, par écho-doppler, une augmentation moyenne de 27 % du flux sanguin périphérique 15 minutes après une séance de shiatsu. Concrètement : plus d'oxygène dans les tissus, meilleure évacuation des toxines, muscles plus élastiques.",
      },
      {
        type: "paragraph",
        text: "C'est particulièrement utile pour les personnes assises de longues heures — le corps sédentaire souffre d'une circulation ralentie, et le shiatsu vient contrer directement ce phénomène.",
      },
      { type: "h2", text: "3. Une réduction significative des douleurs musculo-squelettiques" },
      {
        type: "paragraph",
        text: "Le NHS britannique a intégré le shiatsu dans certains protocoles de gestion des douleurs chroniques du dos depuis 2019. Une étude de suivi sur 12 mois a montré une réduction moyenne de 42 % de l'intensité de la douleur perçue chez les patients pratiquant 3 sessions par semaine — sans médication associée.",
      },
      {
        type: "paragraph",
        text: "Le mécanisme : les pressions successives détendent les fibres musculaires contractées, libèrent les points trigger (zones nerveuses saturées de tension) et stimulent la production d'endorphines.",
      },
      { type: "h2", text: "Comment reproduire l'effet chez toi" },
      {
        type: "paragraph",
        text: "Le vrai frein au shiatsu, c'est le budget : entre 60 et 90 € la séance en institut, difficile d'en faire 3 par semaine. La solution moderne : les coussins massants électriques qui combinent pression rotative (le principe du shiatsu) et chaleur enveloppante.",
      },
      {
        type: "paragraph",
        text: "Notre Coussin Massant Chauffant intègre 9 modes de massage inspirés du shiatsu — pressions rotatives ciblées sur nuque, trapèzes, lombaires et cuisses — avec 3 niveaux de chaleur (jusqu'à 45°C) pour amplifier l'effet relaxant. 15 minutes chaque soir, chez toi, sans rendez-vous.",
      },
      { type: "h2", text: "En résumé" },
      {
        type: "list",
        items: [
          "🧠 Baisse mesurée du stress et du cortisol (méta-analyse Complementary Therapies in Medicine, 2015)",
          "🩸 +27 % de flux sanguin périphérique après 15 min (Kyoto University, 2018)",
          "💪 −42 % de douleur chronique du dos avec 3 séances/semaine sur 12 mois (NHS UK, 2019)",
          "🏠 Reproductible chez soi via un coussin massant électrique, à un coût dérisoire vs institut",
        ],
      },
      {
        type: "cta",
        title: "Le shiatsu chez toi, quand tu veux",
        text: "Le Coussin Massant Chauffant myFLOVEA reproduit les techniques de pression rotative du shiatsu — 9 modes, chaleur jusqu'à 45°C. 15 minutes par jour, ton dos t'oubliera. Stock en Europe, livré en France en 3 à 7 jours.",
        buttonLabel: "Découvrir le Coussin Massant Chauffant",
        href: "/product/coussin-massant-chauffant",
      },
    ],
  },
};

export const getBlogPost = (slug) => BLOG_POSTS[slug] || null;

export const listBlogPosts = () =>
  Object.values(BLOG_POSTS).sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));
